// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qsiq","index":"styles_index__3eu6_"};